export default __webpack_public_path__ + "static/media/taniec.164113a1.svg";